import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const FullscreenIcon = ({ className = '', width = 13,  height = 13 , color = 'currentColor' }) => {
    return (
        <>
            <svg
                className={`md-hide icon-13-13 ${className ? className : ''}`}
                fill='none'
                height={height}
                viewBox='0 0 13 13'
                width={width}
                xmlns='http://www.w3.org/2000/svg'>
                <path
                    clipRule='evenodd'
                    d='M3.5 0.149902H0.650024H0.150024V0.649902V3.5H1.15002V1.1499H3.5V0.149902ZM3.5 11.8499H1.15002V9.5H0.150024V12.3499V12.8499H0.650024H3.5V11.8499ZM9.5 12.8499V11.8499H11.85V9.5H12.85V12.3499V12.8499H12.35H9.5ZM9.5 1.1499V0.149902H12.35H12.85V0.649902V3.5H11.85V1.1499H9.5Z'
                    fill={color}
                    fillRule='evenodd'/>
            </svg>
            <svg
                className={`hide md-show icon-42-42 ${className ? className : ''}`}
                fill='none'
                height={height || 42}
                viewBox='0 0 41 42'
                width={width || 41}
                xmlns='http://www.w3.org/2000/svg'>
                <path
                    clipRule='evenodd'
                    d='M32.6341 9.26807L25.2536 9.26807L25.2536 10.2598H30.8512L23.4246 17.6864L24.1281 18.3899L31.6367 10.8813V16.6066H32.6341L32.6341 9.26807Z'
                    fill={color}
                    fillRule='evenodd'/>
                <path
                    clipRule='evenodd'
                    d='M8.57563 33.2393L15.9561 33.2393L15.9561 32.2475H10.3585L17.7852 24.8209L17.0817 24.1174L9.57306 31.626L9.57306 25.9008L8.57563 25.9008L8.57563 33.2393Z'
                    fill={color}
                    fillRule='evenodd'/>
            </svg>

        </>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default FullscreenIcon;
